
import { defineAsyncComponent, computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import UsersByComputerList from "@/helpers/pages/UsersByComputerList";
import moment from "moment";
import Swal from "sweetalert2";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";
import EventBus from "@/helpers/EventBus";
import { Roles } from "@/helpers/enums/Roles";
import dateOptions from "@/helpers/DateOptions";
import api from "@/api/index";

export default defineComponent({
  name: "UsersByComputerList",
  setup() {
    const route = useRoute();
    const module = ref(UsersByComputerList);
    const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    const user: any = computed(() => store.getters.loggedInUser);
    const group: any = computed(() => store.getters.group);

    let filter: any = ref({
      page: 1,
      limit: 10,
      groupGuids: [],
      computer: "",
      protectionStatusFilter: ""
    });

    const RESETFILTER = filter;
    const getList = async (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      store.dispatch(GeneralActionTypes.GET_COMPUTER_LIST_BY_USER, body);
    };

    const searchWithFilters = (param: any) => {
      filter.value.groupGuids = [];
      if (user.value.role == Roles.GroupAdmin && group.value.key) {
        filter.value.groupGuids.push(group.value.key);
      } else {
        filter.value.groupGuids.push(module.value.filter.filters[0].vmodel);
      }

      filter.value.computer = module.value.filter.filters[1].vmodel || "";
      filter.value.protectionStatusFilter = module.value.filter.filters[2].vmodel || "";
      const filters = filter.value;
      const options = module.value.component.options;
      options.page = 1;
      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item: any) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[2].value;
          item.selectedLabel = dateOptions[2].label;
        } else {
          item.vmodel = null;
        }
      });

      searchWithFilters(true);
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
    };
  },
  computed: {
    statusParam(): any {
      return this.$route.params.status;
    },
  },
  methods: {},
  mounted() {
    EventBus.on("computerLoad", (data: any) => {
      const options = this.module.component.options;
      this.getList(filters, options);
    });
    this.setFilterStatus();
    const filters = this.filter;
    const options = this.module.component.options;
    options.page = 1;
    this.getList(filters, options);
  },
  components: { AgCard },
});
